module.exports = __webpack_public_path__ + "static/expert-1@2x-a2096fffc91598f9bc63832d34267688.png";